import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const getFollowUpMessages = async (bloodUsageId) => {
  try {
    const user = await getStorage();

    const options = {
      method: "GET",
      url: `${API_URL}/bloodUsageFollowUp`,
      params: { bloodUsage: bloodUsageId, limit: 100 },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);
    return queryRes.data;
  } catch (error) {
    toastMessage("error", error);
  }
};

export const addFollowUpMessage = async (bloodUsage, message) => {
  try {
    const user = await getStorage();

    const options = {
      method: "POST",
      url: `${API_URL}/bloodUsageFollowUp`,
      data: { bloodUsage, message, sender: user._id },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);
    return queryRes.data;
  } catch (error) {
    toastMessage("error", error);
  }
};
